<template>
  <div>
    <MobileHeader v-if="isMobileScreen" is-live />
    <DesktopHeader v-else is-live />
  </div>
</template>

<script>
import DesktopHeader from './__DesktopHeader';
import MobileHeader from '../Header';
import { isMobile } from 'mobile-device-detect';
import $ from 'jquery'

export default {

  data() {
    return {
      isMobileScreen: false
    }
  },

  components: {
    DesktopHeader,
    MobileHeader
  },

  mounted() {
    this.checkSmallerDevice();

    $(window).resize(() => {
      this.checkSmallerDevice();
    })
  },

  methods: {
    checkSmallerDevice() {
      const windowWidth = $(window).width();
      
      if (isMobile || windowWidth < 1055) {
        this.isMobileScreen = true;
      } else {
        this.isMobileScreen = false;
      }
    }
  }
  
}
</script>

<style lang="scss" scoped>

</style>